<template>
    <button @click="$emit('click')" type="button" class="focus:outline-none text-white bg-pink-700 hover:bg-pink-800 focus:ring-4 focus:ring-pink-300 font-medium rounded-lg text-sm px-5 py-3 me-2 mb-2 dark:bg-pink-600 dark:hover:bg-pink-700 dark:focus:ring-pink-900 tracking-wide">
        <slot></slot>
    </button>
</template>
<script>
export default {

}
</script>